<template>
  <div id="app">
    <navigation v-if="$route.meta.show"></navigation>
    <router-view />
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
export default {
  name: "App",
  data() {
    return {
      timer: false,
      screenWidth: document.body.clientWidth,
    };
  },
  components: {
    Navigation,
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.screenWidth = window.screenWidth || document.body.clientWidth;
      })();
    };
  },

  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        setTimeout(() => {
          // 打印screenWidth变化的值
          this.timer = false;
          if (val < 750) {
            if (this.$route.path != "/wap") {
              this.$router.replace("/wap");
            }
          } else {
            if (this.$route.path != "/") {
              this.$router.replace("/");
            }
          }
        }, 400);
      }
    },
  },
};
</script>

<style>
body,
button {
  margin: 0;
  padding: 0;
}
body::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
body::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 3px;
  width: 0.06rem;
  height: 0.01rem !important;
  background: rgba(36, 46, 66, 0.1);
}
body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  border-radius: 0;
  background: #fff;
  margin-left: 0.4rem;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-column-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
* {
  box-sizing: border-box;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue